export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поля форми №"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Немає обов'язкового ідентифікатора"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви успішно авторизувалися, продовжите операції на банкоматі"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Продовжіть операції на банкоматі"])}
}